import dieaseList from '../pages/AllergiesDashboard/diseaseDisplayOptions'
export default function getAllergyDiseaseNameById(string_value) {
    let finalstring 
    dieaseList.forEach((disease) => {
        if(disease.value === string_value)
            {finalstring=disease.label}
      
    })
    return finalstring
  }